import { FAILURE, SUCCESS } from "../../../../constants/BaseConstants";
import { call, put, select } from "redux-saga/effects";

import { SEND_NEW_SCHOOL } from "../../../../constants/SchoolConstants";
import getIdSelector from "../../../selectors/ClientSelectors/getIdSelector";
import getSchoolNewFieldSelector from "../../../selectors/SchoolSelectors/getSchoolNewFieldSelector";
import getSchoolNewFieldsSelector from "../../../selectors/SchoolSelectors/getSchoolNewFieldsSelector";
import sendNewSchoolCall from "../../../../api/SchoolCalls/sendNewSchoolCall";

export default function* sendNewSchoolSaga(): any {
    try {
        const fields = yield select(getSchoolNewFieldsSelector);
        let categories = yield select(getSchoolNewFieldSelector, "categories");
        const authorId = yield select(getIdSelector);
        categories = categories.map((category: SchoolCategory) => category.term_id);
        const school = yield call(sendNewSchoolCall, fields, authorId, categories);
        yield put({ type: SEND_NEW_SCHOOL + SUCCESS, school });
    } catch (error) {
        yield put({ type: SEND_NEW_SCHOOL + FAILURE, error });
    }
}
